export default __webpack_public_path__ + "static/media/Glagoli-logo.ca97d9eb.svg";